/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Explorer_Info_Due_Date_ConfirmInputs */



/**
* | output |
* | --- |
* | "Save Due Date" |
*
* @param {Explorer_Info_Due_Date_ConfirmInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const explorer_info_due_date_confirm = /** @type {((inputs?: Explorer_Info_Due_Date_ConfirmInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Explorer_Info_Due_Date_ConfirmInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Save Due Date")
	if (locale === "de") return /** @type {LocalizedString} */ ("Save Due Date")
	if (locale === "it") return /** @type {LocalizedString} */ ("Save Due Date")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Save Due Date")
	if (locale === "es") return /** @type {LocalizedString} */ ("Save Due Date")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("Save Due Date")
	if (locale === "ja") return /** @type {LocalizedString} */ ("Save Due Date")
	if (locale === "hi") return /** @type {LocalizedString} */ ("Save Due Date")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Save Due Date")
	return /** @type {LocalizedString} */ ("Save Due Date")
});